module.exports = __webpack_public_path__ + "static/media/helpIcon.2d7adf68.png";